import {Component, OnInit} from '@angular/core';
import {Job} from '../../../model/Job';
import {JobService} from '../../../service/job.service';
import {AuthService} from '../../../service/auth/auth.service';
import {Constant} from '../../../../global/util/Constant';
import {Page} from '../../../../global/util/enum/Page';
import {InformType} from '../../../../global/util/enum/InformType';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {AddEditJobComponent} from '../add-edit-job/add-edit-job.component';
import {Enterprise} from '../../../model/Enterprise';
import {CloneTool} from '../../../../global/util/CloneTool';
import {ConfirmComponent} from '../../../../shared/confirm/confirm.component';
import {Response} from '../../../../global/util/enum/Response';
import {Partner} from '../../../model/Partner';
import {Dialog} from '../../../../global/util/Dialog';
import {TranslateService} from '@ngx-translate/core';
import {Pagination} from '../../../../global/util/Pagination';
import {EnterpriseService} from '../../../service/enterprise.service';
import {EnterpriseDataService} from '../../../service/data/enterprise-data.service';

@Component({
  selector: 'app-list-job',
  templateUrl: './list-job.component.html',
  styleUrls: ['./list-job.component.css']
})
export class ListJobComponent implements OnInit {

  public jobs: Job[] = [];
  public enterprises: Enterprise[] = LocalStorage.getDefaultEnterprise();
  public enterpriseIdSelected: number;
  public page: any = {};
  public links: any = {};
  private jobUrl: string;
  public enumPage = Page;
  public loading: boolean;
  public title = 'TITLE.JOB';
  public entityName: string;
  public enterpriseSelected: Enterprise;
  public ROLE_SUPERADMIN = Constant.ROLE_SUPERADMIN;
  public ROLE_PARTNER = Constant.ROLE_PARTNER;
  public ROLE_ADMIN = Constant.ROLE_ADMIN;
  public ROLE_USER = Constant.ROLE_USER;
  public partnerSelected: Partner;
  public partners: Partner[] = [];
  pageNumber: any;
  pageNumbers: any[] = [];

  constructor(public jobService: JobService,
              private modalService: NgbModal,
              public authenticationService: AuthService,
              public enterpriseService: EnterpriseService,
              public enterpriseDataService: EnterpriseDataService,
              private translate: TranslateService) {
    Dialog.createInstance(modalService);
  }

  ngOnInit() {
    this.pageNumbers = Pagination.getNumbers();
    this.pageNumber = this.pageNumbers[0].value;
    this.enterprises = LocalStorage.getDefaultEnterprise();
    this.enterpriseSelected = this.enterprises[Constant.ZERO_INDEX];
    this.loadDefaultData();
  }

  private loadDefaultData() {
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      this.partners = LocalStorage.getPartners();
      this.partnerSelected = this.partners[Constant.ZERO_INDEX];
      this.getEnterprises();
    } else if (this.hasRole(this.ROLE_PARTNER)) {
      const partnerId = LocalStorage.getPartnerId();
      this.getEnterprisesById(partnerId);
    } else {
      this.enterpriseIdSelected = LocalStorage.getEnterpriseIdView();
      this.loadJobs(Page.First);
    }
  }

  public reloadJobs() {
    this.enterpriseIdSelected = this.enterpriseSelected.id;
    this.loadJobs(Page.First);
  }

  public loadJobs(page: Page): void {
    const partnerId: number = this.hasRole(this.ROLE_SUPERADMIN) ? this.partnerSelected.id : LocalStorage.getPartnerId();
    switch (page) {
      case Page.First:
        this.jobUrl = Constant.ROOT_API_V1
          .concat('/partners/')
          .concat(String(partnerId))
          .concat('/enterprises/')
          .concat(String(this.enterpriseIdSelected))
          .concat('/jobs?')
          .concat('&size=').concat(this.pageNumber).concat('&sort=id,desc');
        break;
      case Page.Previous:
        this.jobUrl = this.links.prev.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Next:
        this.jobUrl = this.links.next.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Last:
        this.jobUrl = this.links.last.href.replace('http', Constant.SCHEMA);
        break;
      default:
        this.jobUrl = this.links.self.href.replace('http', Constant.SCHEMA);
        break;
    }
    this.getJobs(this.jobUrl);
  }

  private getJobs(url: string) {
    this.loading = true;
    this.entityName = this.translate.instant('TITLE.JOBS');
    this.jobService.get(url).subscribe((next: any) => {
      this.loading = false;
      if (next._embedded) {
        this.jobs = next._embedded.jobs;
      } else {
        this.jobs = [];
      }
      this.page = next.page;
      this.links = next._links;
    }, error => {
      this.loading = false;
      if (HttpStatusCode.UNAUTHORIZED === error.error.status) {
        Dialog.show(InformType.Danger, this.entityName, error.error.message);
      } else {
        Dialog.show(InformType.Danger, this.entityName);
      }
    });
  }

  public openAddModal() {
    this.loading = true;
    this.loading = false;
    this.entityName = this.translate.instant('TITLE.JOB');
    const modalRef = this.modalService.open(AddEditJobComponent, {
      backdrop: 'static'
    });
    modalRef.componentInstance.job = new Job();
    modalRef.componentInstance.jobs = this.jobs;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.loadJobs(Page.Self);
        Dialog.show(InformType.Success, this.entityName);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.entityName);
      } else if (InformType.Warning === result) {
        Dialog.show(InformType.Warning, this.entityName, this.translate.instant('MESSAGE.JOB-HAS-ALREADY-REGISTERED'));
      }
    });
  }

  public openModalEdit(job: Job) {
    const job2Edit = CloneTool.do(job);
    this.entityName = this.translate.instant('TITLE.JOB');
    const modalRef = this.modalService.open(AddEditJobComponent, {
      backdrop: 'static'
    });
    modalRef.componentInstance.job = job2Edit;
    modalRef.componentInstance.jobs = this.jobs;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.loadJobs(Page.Self);
        Dialog.show(InformType.Success, this.entityName);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.entityName);
      } else if (InformType.Warning === result) {
        Dialog.show(InformType.Warning, this.entityName, 'MESSAGE.JOB-HAS-ALREADY-REGISTERED');
      }
    });
  }

  public hasRole(name: string) {
    return this.authenticationService.hasRole(name);
  }

  public hasAuthority(code: string): boolean {
    return this.authenticationService.hasAuthority(code);
  }

  public openModalDelete(job: Job) {
    const modalRef = this.modalService.open(ConfirmComponent);
    modalRef.componentInstance.title = 'TITLE.DELETE-JOB';
    modalRef.componentInstance.body = 'QUESTION.ARE-YOU-SURE-DELETE-JOB';
    modalRef.result.then((result) => {
      if (Response.Yes === result) {
        this.delete(job);
      }
    });
  }

  private delete(job: Job) {
    this.loading = true;
    this.entityName = this.translate.instant('TITLE.JOB');
    this.jobService.delete(job).subscribe(job1 => {
      LocalStorage.updateEmbeddedValuesBy(job1, 'jobs', Constant.DELETE);
      this.loading = false;
      this.loadJobs(Page.Self);
      Dialog.show(InformType.Success, this.entityName);
    }, () => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.entityName);
    });
  }

  public reloadJobs0() {
    this.getEnterpriseFilteredBy(this.partnerSelected.id);
  }

  private getEnterprises() {
    this.enterpriseService.getAllEnterprises().subscribe(enterprises => {
      this.enterpriseDataService.setEnterprises(enterprises.sort());
      this.enterprises = LocalStorage.addEnterprise(enterprises).sort();
      this.enterpriseSelected = this.enterprises[Constant.ZERO_INDEX];
      this.enterpriseIdSelected = this.enterpriseSelected.id;
      this.loadJobs(Page.First);
    });
  }

  private getEnterprisesById(partnerId: number) {
    this.enterpriseService.getAllEnterprisesByPartner(partnerId).subscribe(enterprises => {
      this.enterpriseDataService.setEnterprises(enterprises.sort());
      this.enterprises = enterprises.sort();
      this.enterpriseSelected = this.enterprises[Constant.ZERO_INDEX];
      this.enterpriseIdSelected = this.enterpriseSelected.id;
      this.loadJobs(Page.First);
    });
  }

  /**
   * Filtra la empresa al seleccionar el partner
   * @param partnerId
   * @private
   */
  private getEnterpriseFilteredBy(partnerId: number): void {
    const enters = this.enterpriseDataService.getEnterprises();
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      if (partnerId === Constant.ALL_PARTNER_ID) {
        this.enterprises = LocalStorage.getDefaultEnterprise();
      }
      const enterprisesFilter = enters.filter(value => partnerId === value.partnerId);
      this.enterprises = LocalStorage.addEnterprise(enterprisesFilter);
      this.enterpriseSelected = this.enterprises[Constant.ZERO_INDEX];
      this.enterpriseIdSelected = this.enterpriseSelected.id;
      this.reloadJobs();
    }
  }
}
